package com.zq.webproject.utils

import kotlinx.browser.window

/**
 * Web平台URL启动器实现
 */
actual object UrlLauncher {
    /**
     * 在浏览器中打开URL
     */
    actual fun openUrl(url: String) {
        println("UrlLauncher - Web平台打开URL: $url")
        try {
            // 使用 window.open 在新标签页打开链接
            val newWindow = window.open(url, "_blank")
            if (newWindow != null) {
                println("UrlLauncher - 新标签页打开成功")
            } else {
                println("UrlLauncher - 浏览器阻止了弹窗，请允许弹窗后重试")
            }
        } catch (e: Exception) {
            println("UrlLauncher - 打开URL失败: ${e.message}")
            e.printStackTrace()
        }
    }
}
